var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.is_profile_completed && !_vm.finish_profile && _vm.getTenantAccess === null)?_c('FinishProfile',{on:{"done":function($event){_vm.finish_profile = true;}}}):_c('landlord-contracts')}
var staticRenderFns = []

export { render, staticRenderFns }